import { useAppSelector } from "../../hooks/StoreHooks";

export const useAppDesignCompanyLogo = () =>
    useAppSelector((state) => state.configuration.appDesign?.companyLogo);

export const useAppDesignAccentColor = () =>
    useAppSelector((state) => state.configuration.appDesign?.accentColor);

